<template>
  <div v-click-outside="closeList" class="position-relative">
    <input
      placeholder="جستجو"
      :value="searchQuery"
      @focus="setFocus"
      @input="updateQuery"
      @keyup="
        updateSearchQuery()
        onKeyUp()
      "
      :class="{ input: $route.name === 'courses-package' || $route.name === 'course-prerequisites' || $route.name === 'package-prerequisites' || $route.name === 'course-users' }"
    />
    <template
      v-if="show && ($route.name === 'courses-package' || $route.name === 'course-prerequisites' || $route.name === 'package-prerequisites' || $route.name === 'campaign-detail')"
    >
      <div v-if="loading" class="list-loading">
        <Loader :loading="loading" />
      </div>
      <div v-if="!loading && list.length === 0" class="list-loading">نتیجه ای یافت نشد!</div>
      <div v-if="list.length" class="list">
        <div v-for="(item, index) in list" :key="index">
          <div :class="['d-flex position-relative item', { __is_not_buy_able: !item.isBuyable && $route.fullPath.includes('universitypackagecourses') }]">
            <div class="image">
              <img v-if="item.image" :src="item.image" />
              <img v-else src="../../../assets/images/brandDefaultPicture.svg" />
            </div>
            <div class="info">
              <div class="title">{{ item.description }}</div>
              <div class="subtitle">{{ item.subDecsription }}</div>
            </div>
            <div
              v-if="
                ($route.fullPath.includes('universitypackagecourses') && item.isBuyable) ||
                $route.name === 'course-prerequisites' ||
                $route.name === 'package-prerequisites' ||
                $route.name === 'courses-package' ||
                $route.name === 'campaign-detail'
              "
              class="list-btn"
              @click="buttonHandle(item)"
            >
              + اضافه کردن
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-if="show && $route.name === 'course-users'">
      <div v-if="loading" class="list-loading">
        <Loader :loading="loading" />
      </div>
      <div v-if="!loading && list.length === 0" class="list-loading">نتیجه ای یافت نشد!</div>
      <div class="scroll">
        <div v-if="list.length" class="user-list">
          <div class="d-flex position-relative item" v-for="(item, index) in list" :key="index" @click="addSelectedUser(item)">
            <div class="user-image">
              <img v-if="item.image" :src="item.image" />
              <img v-else src="../../../assets/images/users/default.png" />
            </div>
            <div class="user">
              <div class="name">
                {{ item.fullName }}
              </div>
              <hr class="custom-hr" v-if="!item.fullName" />
              <div class="phone">
                {{ item.phone }}
              </div>
              <hr v-if="!item.phone" class="custom-hr" />
              <div class="nationalCode">
                {{ item.nationalCode }}
              </div>
              <hr v-if="!item.nationalCode" class="custom-hr" />
            </div>
          </div>
        </div>
        <div v-else class="user-list"></div>
        <div v-if="list.length" class="add-user" @click="$bvModal.show('user-modal')">
          <img src="../../../assets/images/purple-plus.svg" />
          اضافه کردن
        </div>
      </div>
    </template>
    <Toast :showToast="showToast" :title="toastTitle" :error="error" />
    <b-modal id="user-modal" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>کاربر جدید</template>
      <div class="px-3 py-2">
        <BaseText
          :value="model.firstName"
          @input="model.firstName = $event"
          title="نام"
          placeholder="نام"
          required
          :errortext="errorText"
          :showError="submit && !model.firstName"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="model.lastName"
          @input="model.lastName = $event"
          title="نام خانوادگی"
          placeholder="نام خانوادگی"
          required
          :errortext="errorText"
          :showError="submit && !model.lastName"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="model.phoneNumber"
          @input="model.phoneNumber = $event"
          title="تلفن همراه"
          placeholder="تلفن همراه"
          :maxlength="11"
          required
          :errortext="phoneNumberErrorText || errorText"
          :showError="(submit && !model.phoneNumber) || (submit && phoneNumberError)"
        />
      </div>
      <div class="px-3 py-2">
        <BaseText :value="model.nationalCode" @input="model.nationalCode = $event" title="کدملی" placeholder="کدملی" />
      </div>
      <div class="p-3 py-2 d-flex flex-row justify-content-end">
        <b-button @click="closeModal">انصراف</b-button>
        <Button @click.native="createSearchUser" :loading="submitLoading" text="ثبت" btnClass="upload-btn btn-border" />
      </div>
    </b-modal>

    <b-modal id="order-modal" size="lg" no-close-on-esc hide-footer centered header-close-variant="dark" cancel-title>
      <template #modal-title>ثبت سفارش آفلاین</template>
      <div class="px-3 py-2">
        <TextAreaInput :value="user.decription" @input="user.decription = $event" title="شرح تراکنش" required :errortext="errorText" :showError="submit && !user.decription" />
      </div>
      <div class="px-3 py-2">
        <BaseText
          :value="user.price"
          @input="user.price = $event"
          title="مبلغ تراکنش "
          placeholder="مبلغ تراکنش "
          required
          :errortext="priceErrorText || errorText"
          :showError="(submit && !user.price) || (submit && priceErrorText.length)"
          subLabel="مبلغ تراکنش از موجودی کیف پول شما به ازای هر کاربر کسر میگردد. "
        />
      </div>

      <div class="p-3 py-2 d-flex flex-row justify-content-between">
        <div style="color: #f46a6a">
          <span v-if="addUserMessage">{{ addUserMessage }}</span>
        </div>
        <div class="d-flex">
          <b-button @click="closeModal">انصراف</b-button>
          <Button @click.native="submitNewUserOrder" :loading="submitLoading" text="ثبت" btnClass="upload-btn btn-border" />
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { urlQueriesMixins } from '../../../utils/mixins'
import dadbanPackageProvider from '../../../services/dadban/package'
import moocPackageProvider from '../../../services/mooc/package'
import dadbanCourseProvider from '../../../services/dadban/course'
import moocUsersProvider from '../../../services/mooc/user'
import Loader from '../../widgets/loader.vue'
import Toast from '../Toast.vue'
import dadbanUsersProvider from '../../../services/dadban/user'
import BaseText from '../form/formModules/BaseText.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'
import Button from '../Button.vue'
import userDataProvider from '../../../services/user'
import dadbanCampaignProvider from '../../../services/dadban/campaign'
export default {
  name: 'table-header-input',
  components: { Loader, Toast, BaseText, Button, TextAreaInput },
  mixins: [urlQueriesMixins],
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    productPrice: {
      type: Number,
    },
  },
  data() {
    return {
      // searchedValue: '',
      loading: false,
      submitLoading: false,
      show: false,
      notFound: false,
      showToast: false,
      toastTitle: '',
      error: false,
      model: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        nationalCode: '',
        productId: +this.$route.params.courseId || +this.$route.params.packageId,
        productType: this.$route.params.courseId ? 0 : 1,
      },
      user: {
        price: '',
        decription: '',
      },
      addUserMessage: '',
      errorText: 'وارد کردن این فیلد الزامی است',
      priceErrorText: '',
      submit: false,
      phoneNumberErrorText: '',
      phoneNumberError: false,
    }
  },
  watch: {
    '$route.query.query.length'(c) {
      if (c === 0 || !c) {
        if (
          this.$route.name === 'courses-package' ||
          this.$route.name === 'course-prerequisites' ||
          this.$route.name === 'package-prerequisites' ||
          this.$route.name === 'campaign-detail' ||
          this.$route.name === 'course-users'
        ) {
          this.setFocus()
        }
      }
    },
    'user.price'(c) {
      if (c && +c > 0) {
        this.priceErrorText = ''
      }
      if (c) {
        this.user.price = this.user.price.toString()
        this.user.price = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
    },
  },
  beforeDestroy() {
    this.show = false
  },
  methods: {
    parsePrice(price) {
      if (!price) return 0
      return +price.toString().replace(/,/g, '')
    },
    onKeyUp() {
      this.$emit('onKeyUp', true)
    },
    updateSearchQuery() {
      console.log('updateSearchQuery', this.searchQuery)
      this.$store.dispatch('urlQueries/setSearchQuery', this.searchQuery)
    },
    updateQuery(e) {
      this.$store.dispatch('urlQueries/setSearchQuery', e.target.value)
    },
    setFocus() {
      if (
        this.$route.name === 'courses-package' ||
        this.$route.name === 'course-prerequisites' ||
        this.$route.name === 'package-prerequisites' ||
        this.$route.name === 'campaign-detail' ||
        this.$route.name === 'course-users'
      ) {
        this.loading = true
        this.show = true
        this.$emit('focused')
        setTimeout(() => {
          if (this.list.length === 0) {
            this.loading = false
            this.notFound = true
          }
        }, 3000)
      }
    },
    closeList() {
      this.show = false
    },
    buttonHandle(item) {
      if (this.$route.name === 'course-prerequisites') {
        this.addCoursePrerequisites(item)
      }
      if (this.$route.name === 'package-prerequisites') {
        this.addPackagePrerequisites(item)
      }
      if (this.$route.name === 'courses-package') {
        this.addCoursePackage(item)
      }
      if (this.$route.name === 'campaign-detail') {
        this.addCampaignProduct(item)
      }
    },
    async getPackage(id) {
      const req = await moocPackageProvider.getPackage(id)
      if (req.status === 200) this.$route.query.courseLength = req.data.data.output.numberOfAddedCourse
    },
    async addCoursePackage(item) {
      try {
        this.show = false
        const body = {
          courseId: item.id,
          packageId: +this.$route.params.packageId,
        }
        if (this.$route.path.includes('university')) {
          await moocPackageProvider.addPackageCourse(body)
        } else {
          await dadbanPackageProvider.addPackageCourse(body)
        }
        this.$emit('update')
        this.getPackage(+this.$route.params.packageId)
      } catch (error) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = true
          this.toastTitle = error.response.data.message
        })
      }
    },
    async addCoursePrerequisites(item) {
      this.show = false
      await dadbanCourseProvider.addCoursePrerequisite({
        courseId: this.$route.params.courseId,
        prerequisiteId: item.id,
      })
      this.$emit('update')
    },
    async addCampaignProduct(item) {
      this.show = false
      await dadbanCampaignProvider.addProduct({
        productType: item.entityType,
        productId: item.id,
        campaignId: +this.$route.params.id,
      })

      this.$emit('update')
    },
    async addPackagePrerequisites(item) {
      this.show = false
      await dadbanPackageProvider.addPackagePrerequisite({
        packageId: this.$route.params.packageId,
        prerequisiteId: item.id,
      })
      this.$emit('update')
    },
    async addSelectedUser(user) {
      this.user = {
        ...this.user,
        productId: +this.$route.params.courseId || +this.$route.params.packageId,
        productType: this.$route.params.courseId ? 0 : 1,
        userId: user.id,
        firstName: user.firstName,
        lastName: user.lastName,
        image: user.image,
        nationalCode: user.nationalCode,
        phoneNumber: user.phone,
      }
      if (this.productPrice > 0) {
        this.$bvModal.show('order-modal')
        return
      } else {
        try {
          this.submitLoading = true
          const parsedPrice = this.parsePrice(this.user.price || '0')
          let req = ''

          req = await dadbanUsersProvider.addFreeSearchUser({ ...this.user, price: parsedPrice })
          if (req.data.data.isSuccessful === false) {
            this.submitLoading = false
            this.error = true
            this.showToast = true
            this.toastTitle = 'کاربر قبلا به لیست اضافه شده است.'
          } else {
            this.$emit('update')
            this.toastTitle = 'کاربر با موفقیت اضافه شد'
            this.showToast = true
            this.addUserMessage = req.data.output
          }
          setTimeout(() => {
            this.showToast = false
            this.error = false
            this.priceErrorText = ''
          }, 5000)
          this.show = false
          this.closeModal()
          this.submitLoading = false
        } catch (error) {
          this.addUserMessage = error.response.data.message
          this.submitLoading = false
        }
      }
    },
    async submitNewUserOrder() {
      this.submit = true
      this.addUserMessage = ''
      if (!this.user.decription || !this.user.price) {
        return
      }
      if (this.user.price && +this.user.price <= 0) {
        this.priceErrorText = 'مبلغ باید بزرگتر از صفر باشد.'
        return
      }
      const parsedPrice = this.parsePrice(this.user.price)
      if (parsedPrice <= 0) {
        this.priceErrorText = 'مبلغ باید بزرگتر از صفر باشد.'
        return
      }

      try {
        this.submitLoading = true
        let req = ''
        req = await dadbanUsersProvider.addSearchUser({ ...this.user, price: parsedPrice })
        if (req.data.data === false) {
          this.submitLoading = false
          this.error = true
          this.showToast = true
          this.toastTitle = 'کاربر قبلا به لیست اضافه شده است.'
        } else {
          this.$emit('update')
          this.toastTitle = 'کاربر با موفقیت اضافه شد'
          this.showToast = true
          this.addUserMessage = req.data.output
        }
        setTimeout(() => {
          this.showToast = false
          this.error = false
          this.priceErrorText = ''
        }, 5000)
        this.show = false
        this.closeModal()
        this.submitLoading = false
      } catch (error) {
        this.addUserMessage = error.response.data.message
        this.submitLoading = false
      }
    },
    async createSearchUser() {
      this.submit = true
      if ((!this.model.firstName && !this.model.lastName) || !this.model.phoneNumber) {
        return false
      } else if (this.model.phoneNumber) {
        const mobileNumberRegex = /^09\d{9}$/
        const checkMobileNumber = mobileNumberRegex.test(String(this.model.phoneNumber))
        if (!checkMobileNumber) {
          this.phoneNumberError = true
          this.phoneNumberErrorText = 'شماره همراه کاربر را صحیح وارد نمایید .'
          return false
        }
      }
      this.submitLoading = true
      try {
        let req
        if (this.$route.path.includes('university')) {
          req = await moocUsersProvider.creatSearchUser(this.model)
        } else {
          req = await userDataProvider.addNewUser({ ...this.model, mobile: this.model.phoneNumber })
        }
        this.addSelectedUser({
          firstName: this.model.firstName,
          lastName: this.model.lastName,
          phone: this.model.phoneNumber,
          productId: this.model.productId,
          productType: this.model.productType,
        })

        this.submitLoading = false

        this.$emit('update')
        this.toastTitle = 'کاربر با موفقیت اضافه شد'
        this.showToast = true

        this.$bvModal.hide('user-modal')
        for (const key in this.model) {
          this.model['productId'] = +this.$route.params.courseId || +this.$route.params.packageId
          this.model['productType'] = this.$route.params.courseId ? 0 : 1
        }
        this.submit = false
      } catch (error) {
        this.submitLoading = false
        this.submit = true
        if (error.response.status === 409) {
          this.phoneNumberError = true
          this.phoneNumberErrorText = error.response.data.message
          return false
        }
        for (const key in this.model) {
          this.model['productId'] = +this.$route.params.courseId || +this.$route.params.packageId
          this.model['productType'] = this.$route.params.courseId ? 0 : 1
        }
        setTimeout(() => {
          this.showToast = false
          this.error = false
        }, 5000)
      } finally {
        this.model = {}
      }
    },
    closeModal() {
      this.$bvModal.hide('user-modal')
      this.$bvModal.hide('order-modal')
      this.submitLoading = false
      this.submit = false
      this.priceErrorText = ''
      this.user = {
        price: '',
        description: '',
      }
    },
  },
}
</script>

<style lang="scss" scoped>
input {
  border: 1px solid #e8e8e8;
  box-sizing: border-box;
  border-radius: 3px;
  outline: none;
  width: 250px;
  height: 27px;
}

input::placeholder {
  padding: 0 12px;
}

.input {
  width: 434px;
}

.scroll {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  height: 220px;
  width: 433px;
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  top: 33px;
  right: 0;
  z-index: 100;
}

.user-list {
  overflow-y: auto;
  height: 170px;
}

.list {
  background: #ffffff;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 2px;
  overflow-y: auto;
  height: 220px;
  width: 433px;
  // padding: 10px;
  padding-left: 0;
  position: absolute;
  top: 33px;
  right: 0;
  z-index: 100;
}

.image {
  height: 42px;
  width: 62px;
  border-radius: 2px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
  }
}

.info {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0 10px 0 0;

  .title {
    font-size: 14px;
    width: 250px;
  }

  .subtitle {
    font-size: 12px;
    margin-top: 2px;
  }
}

.list-btn {
  position: absolute;
  left: 5px;
  top: 10px;
  text-align: left;
  font-size: 11px;
  color: #556ee6;
  cursor: pointer;
}

.list-loading {
  @extend .list;
  display: grid;
  place-items: center;
}

.item {
  padding: 15px 10px;

  &:hover {
    background: rgba(85, 110, 230, 0.1);
  }
}

.user {
  display: flex;
  width: 100%;
  justify-content: center;
  cursor: pointer;

  .name {
    position: relative;
    top: 5px;
    margin-right: 10px;
    width: 50%;
  }

  .phone,
  .nationalCode {
    width: 25%;
    color: #999696;
    text-align: center;
    margin-right: 50px;
    position: relative;
    top: 5px;
  }
}

.user-image {
  img {
    width: 28px;
    height: 28px;
    border-radius: 100%;
  }
}

.add-user {
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  color: #556ee6;
  cursor: pointer;
  font-weight: bold;
  padding: 14px;
  border-top: 1px solid #e8e8e8;

  img {
    margin-left: 10px;
  }
}

.upload-btn {
  margin-right: 10px !important;
  background: #556ee6 !important;
  border-radius: 4px !important;
  color: white !important;
  padding: 8px 28px !important;
}

.custom-hr {
  margin: 0 !important;
  bottom: 10px;
  position: relative;
  top: 13px;
  height: 2px;
  background-color: #000 !important;
  opacity: 0.3;
  width: 50px;
  left: 30px;
}

.__is_not_buy_able {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
